<template>
  <div v-if="!isEmpty">
    <div v-for="(val, i) in value" v-bind:key="i" class="alert alert-danger">{{val}}</div>
  </div>
</template>

<script>
export default {
  name: "global-errors",
  computed: {
    isEmpty: function () {
      return !this.value || this.value.length === 0;
    }
  },
  props: ["id", "value"]
}
</script>
